<!--   资源树 -->
<template>
    <div>
        <el-breadcrumb separator="/" class="bread">
            <el-breadcrumb-item :to="{ name: 'index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>资源树</el-breadcrumb-item>
        </el-breadcrumb>
    <el-tree class="menutree"
             v-loading="loading2"
             element-loading-text="拼命加载中"
            :data="data2"
            :props="defaultProps"
            node-key="id"
             default-expand-all
             :expand-on-click-node="false"
            :render-content="renderContent">
    </el-tree>
        <el-dialog
                title="编辑"
                :visible.sync="dialogVisibleToEdit"
                size="small"
                :modal="dialogModal"
                @close="dialogClose"
                >

            <el-form :model="form" :rules="menurules" ref="form"  label-width="120px" class="demo-ruleForm"  :label-position="labelposition">
                <el-form-item label="菜单名称" :label-width="formLabelWidth" prop="name">
                    <el-input v-model="form.name" auto-complete="off" ></el-input>
                </el-form-item>
                <el-form-item label="菜单url" :label-width="formLabelWidth" prop="url">
                    <el-input v-model="form.url" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="菜单序号" :label-width="formLabelWidth" prop="order">
                    <el-input v-model="form.order" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="菜单编号" :label-width="formLabelWidth" prop="code">
                    <el-input v-model="form.code" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="菜单描述" :label-width="formLabelWidth">
                    <el-input v-model="form.desc" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="是否是菜单" :label-width="formLabelWidth">
                    <el-switch
                            v-model="form.isMenu"
                            on-color="#13ce66"
                            off-color="#ff4949">
                    </el-switch>

                </el-form-item>
                <!-- 权限设置 -->
                <el-form-item label="Authority Name" :label-width="formLabelWidth">
                    <el-input v-model="form.authorityName" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Authority Url" :label-width="formLabelWidth">
                    <el-input v-model="form.requestUrl" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Authority Method" :label-width="formLabelWidth">
                    <el-input v-model="form.requestMethod" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Authority Params" :label-width="formLabelWidth">
                    <el-input v-model="form.requestParams" auto-complete="off"></el-input>
                </el-form-item>

                <el-form-item>
                        <!--<el-button  @click="redrictTree">取 消</el-button>-->
                    <el-button type="primary" @click="submitForm('form')">确 定</el-button>
                </el-form-item>
            </el-form>

            <!--<menuEdit v-bind:id="dialogParamsById">-->

            <!--</menuEdit>-->
        </el-dialog>


    </div>
</template>
<style>
    @import "../../../assets/css/button.css";
</style>
<script>
//    import  menuEdit from "../menu/MenuEdit.vue"
    export default {
        created () {
            this.getTree()
            if(this.getcookie("tenant_id")!="000000"){
                this.updateBtnState("042");
            }
        },
        data() {

            return {
                data2: [],
                defaultProps: {
                    children: 'children',
                    label: 'name',
                    id: 'id'
                },
                loading2: false,
                formLabelWidth: '120px',
                //dialog
                dialogVisibleToEdit: false,
//                dialogParamsById:"",
                dialogModal: false,

                //----------------------------------------------------------------------------------------edittree stop
                id: "",
                labelposition: "left",
                formLabelWidth: '120px',
                form: {
                    name: '',
                    url: '',
                    order: '',
                    code: '',
                    desc: '',
                    isMenu: '',
                    authorityName: '',
                    requestUrl: '',
                    requestMethod: '',
                    requestParams: '',

                },
                menurules: {
                    name: [
                        {required: true, message: '请输入菜单名称', trigger: 'blur'},
                    ],
                    /* url: [
                     { required: true, message: '请输入菜单的url', trigger: 'blur' },
                     ],*/
                    order: [
                        {required: true, message: '请输入同级菜单的顺序', trigger: 'blur'},
                    ],
                    remark: [
                        {min: 0, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur'}
                    ]
                },btnAll:{
                        btn_0421:true,
                        btn_0422:true,
                        btn_0423:true,
                }
            }
                //----------------------------------------------------------end
        },
//        components:{
//            "menuEdit":menuEdit
//        },
        methods: {

            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            getTree(){
                this.loading2 = true;
                this.$http.get(this.requetHost+'/sys/resource/getTree')
                    .then(response => {
                            if (response.status === 200) {
                                this.data2 = response.body.tree;
                                this.loading2 = false;
                                }else{
                                    this.$message({
                                        showClose: true,
                                        message: '树资源加载不正确',
                                        type: 'error'
                                       });
                            }
                        },function(response){
                            this.$message({
                                showClose: true,
                                message: '网络异常',
                                type: 'error'

                            });
                        }
                    )
            },
            append(store, data) {

                var clevel = parseInt(data.level)+1;
                var childnum = 0;
                if ((data.children !== undefined)&&(data.children !==null)){
                    childnum = data.children.length;
                }
                var order = parseInt(childnum)+1;
                var cid = data.id+order;
                var name = "节点"+cid;
                console.log(name);
                store.append({ id: cid, name: name, children: [] }, data);
                this.$http.post(this.requetHost+'/sys/resource/saveNode', {id:cid,pid:data.id,level:clevel,remark:false,name:name,order:order})
                    .then(response => {
                        this.loading2 = true;
                            if (response.status === 200) {
                                if ( response.body.res == true) {
                                    this.getTree();
                                    setTimeout(() => {
                                        this.loading2 = false;
                                        //this.$router.push('/main');
                                    }, 2000);

                                }else{
                                    this.$message({
                                        showClose: true,
                                        message: '新增节点失败',
                                        type: 'error'

                                    });
                                }
                            }
                        },function(response){
                            this.$message({
                                showClose: true,
                                message: '网络异常',
                                type: 'error'

                            });
                        }
                    );
            },

            remove(store, data) {
                store.remove(data);
                this.$http.post(this.requetHost+'/sys/resource/delNode', {id:data.id})
                    .then(response => {
                            //this.loading2 = true;
                            if (response.status === 200) {
                                if ( response.body.res == true) {
                                    this.$message({
                                        showClose: true,
                                        message: '节点删除成功！',
                                        type: 'success'

                                    });
                                    this.deleteAuthorityByResourcesId(data.id);

                                }else{
                                    this.$message({
                                        showClose: true,
                                        message: '节点删除失败',
                                        type: 'error'

                                    });
                                }
                            }
                        },function(response){
                            this.$message({
                                showClose: true,
                                message: '网络异常',
                                type: 'error'

                            });
                        }
                    );
            },

            editinfo(store, data) {
                this.id=data.id;
                this.dialogVisibleToEdit=true;
                this.toUpdate();
                //this.$router.push( {name:"menuEdit",params:{id:data.id}})
            },

            /*---------------------------------------------编辑 节点----------------------------------------------------*/
                toUpdate(){
                    this.$http.get(this.requetHost+'/sys/resource/findById' ,{params:{"resourceId":this.id}})
                        .then(response => {
                                if (response.status === 200) {

                                    this.form.name = response.body.sysResource.name;
                                    this.form.url = response.body.sysResource.url;
                                    this.form.order = response.body.sysResource.ordernum;
                                    this.form.code = response.body.sysResource.code;
                                    this.form.desc = response.body.sysResource.nodedesc;
                                    //this.treedata =  JSON.stringify(tree);
                                    this.findeAuthorityByResourcesId();
                                    var isMenu=response.body.sysResource.isMenu==1?true:false;
                                    this.form.isMenu=isMenu;
                                }else{
                                    this.$message({
                                        showClose: true,
                                        message: '节点资源加载不正确',
                                        type: 'error'
                                    });
                                }
                            },function(response){
                                this.$message({
                                    showClose: true,
                                    message: '网络异常',
                                    type: 'error'

                                });
                            }
                        )


                },
                submitForm(formName){

                    this.$http.post(this.requetHost + '/sys/resource/editNode', {
                        resourceId: this.id,
                        menuName: this.form.name,
                        url: this.form.url,
                        order: this.form.order,
                        code: this.form.code,
                        describe: this.form.desc,
                        isMenu:this.form.isMenu?1:0
                    })
                        .then(response => {
                                this.loading2 = true;
                                if (response.status === 200) {
                                    if (response.body.res == true) {

                                       // this.$router.push('/content/04/menu');
                                        this.saveAuthority();

                                        setTimeout(() => {
                                            this.loading2 = false;
                                            //this.$router.push('/main');
                                        }, 2000);

                                    } else {
                                        this.$message({
                                            showClose: true,
                                            message: '编辑节点失败',
                                            type: 'error'

                                        });
                                    }
                                }
                            }, function (response) {
                                this.$message({
                                    showClose: true,
                                    message: '网络异常',
                                    type: 'error'

                                });
                            }
                        );

                },
                //----------------------权限操作---------------------------//
                findeAuthorityByResourcesId(){
                    var _this=this;
                    this.$store.dispatch('findeAuthorityByResourcesId',this.id).then((res)=>{
                        if(res.authorityInfo.length>0){
                            var data=res.authorityInfo[0];
                            _this.form.authorityName=data.authority_name;
                            var append="";
                            if(data.authorityUrlList.length>0){
                                for(var i=0;i<data.authorityUrlList.length;i++){
                                    if(i<(data.authorityUrlList.length-1)){
                                        append=",";
                                    }
                                    _this.form.requestUrl=_this.form.requestUrl+data.authorityUrlList[i].requestUrl+append;
                                    _this.form.requestMethod=_this.form.requestMethod+data.authorityUrlList[i].requestMethod+append;
                                    _this.form.requestParams=_this.form.requestParams+data.authorityUrlList[i].requestParams+append
                                }
                            }

                        }
                    });
                },
                saveAuthority(){
                    var _this=this;
                    var params={resourcesId:this.id,
                        authorityName:this.form.authorityName,
                        requestUrl:this.form.requestUrl,
                        requestMethod:this.form.requestMethod,
                        requestParams:this.form.requestParams
                    }
                    this.$store.dispatch('saveAuthority',params).then((res)=>{
                        _this.status=res.status;
                        _this.dialogVisibleToEdit=false;
                        _this.getTree();
                    });
                },

        /*--------------------------------------------------end------------------------------------------------------*/
        //2017/7/8删除节点
        deleteAuthorityByResourcesId(resourcesId){
            var _this=this;
            var params={resourcesId:resourcesId};
            this.$store.dispatch('deleteAuthorityByResourcesId',params).then((res)=>{
                _this.status=res.status;
            });
        }, dialogClose(){
            this.form.authorityName="";
            this.form.requestUrl="";
            this.form.requestMethod="";
            this.form.requestParams="";
            },
            renderContent(h, { node, data, store }) {
                return (
                    <span>
                    <span>
                    <span>{node.label}</span>
                </span>
                <span style="margin-left: 10px">
                    <el-button size="mini" type="primary" on-click={ () => this.append(store, data,) }>添加</el-button>
                <el-button size="mini" type="primary"   on-click={ () => this.remove(store, data) }>删除</el-button>
                <el-button size="mini" type="primary"     on-click={ () => this.editinfo(store, data) }>编辑</el-button>
                </span>
                </span>);
            },
            // v-if="btnAll.btn_0421"   v-if="btnAll.btn_0422" v-if="btnAll.btn_0423"
            /**--------------------------------------end--------------------------------------------------------**/
            updateBtnState(pid){
                var _this=this
                this.$store.dispatch("getButton",pid).then((res)=>{
                    var data=res.btnlist;
                    var btnAlllist=new Array("btn_0421","btn_0422","btn_0423");
                    var btnAlllist1=btnAlllist;
                    if(data.length>0) {
                        for (var i = 0; i < data.length; i++) {
                            var btnId="btn_"+data[i].resourceId;
                            for(var j=0;j<btnAlllist.length;j++){
                                if(btnAlllist[j]==btnId){
                                    btnAlllist1.splice(j,1)
                                }
                            } ;
                        }
                    }
                    //隐藏按钮
                    for(var h=0;h<btnAlllist1.length;h++){
                        if(btnAlllist1[h]=="btn_0421"){
                            _this.btnAll.btn_0421=false;
                        }
                        if(btnAlllist1[h]=="btn_0422"){
                            _this.btnAll.btn_0422=false;
                        }
                        if(btnAlllist1[h]=="btn_0423"){
                            _this.btnAll.btn_0423=false;
                        }

                    }
                })
            },
            /**--------------------------------------end--------------------------------------------------------**/

        }
    }
</SCRIPT>
<style>
    .dialog{
        position:fixed;
        position: fixed;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        margin: auto;
    }
    .menutree {
        margin-top: 28px;
    }
    .bread{
        margin-bottom: 10px;
    }
</style>



// WEBPACK FOOTER //
// MenuTree.vue?3899b7b9